import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.shell.title": "EDU 教学后台",
  "edu.shell.loginTitle": "EDU 教学后台登录",
  "edu.shell.portalAction": "学员端",
  "menu.eduDashboard": "工作台",
  "menu.eduCourses": "课程库",
  "menu.eduCourseDetail": "课程详情",
  "menu.eduTeachingPlans": "教学计划",
  "menu.eduProjects": "培训项目",
  "menu.eduProjectsCourseInstances": "项目课程执行实例",
  "menu.eduProjectsExamResults": "项目考试执行结果",
  "menu.eduPublicCourses": "公开课程",
  "menu.eduMembers": "成员管理",
  "menu.eduOrgs": "组织管理",
  "edu.enums.courseSource.system": "系统内置",
  "edu.enums.courseSource.created": "我创建的",
  "edu.enums.courseSource.referenced": "我引用的",
  "edu.enums.courseSource.cloned": "我克隆的",
  "edu.enums.courseLifecycle.draft": "草稿",
  "edu.enums.courseLifecycle.published": "已发布",
  "edu.enums.courseLifecycle.shared": "已共享",
  "edu.enums.courseLifecycle.reviewing": "审核中",
  "edu.enums.courseLifecycle.rejected": "已驳回",
  "edu.enums.courseLessonType.theory": "理论课时",
  "edu.enums.courseLessonType.practice": "实操课时",
  "edu.enums.courseLessonType.exam": "考试课时",
  "edu.enums.courseLessonType.assignment": "作业课时",
  "edu.enums.courseLessonType.exercise": "练习课时",
  "edu.enums.courseLessonType.discussion": "讨论课时",
  "edu.enums.courseTaskType.rich_text": "图文",
  "edu.enums.courseTaskType.video": "视频",
  "edu.enums.courseTaskType.audio": "音频",
  "edu.enums.courseTaskType.discussion": "讨论",
  "edu.enums.courseTaskType.document": "文档",
  "edu.enums.courseTaskType.ppt": "PPT",
  "edu.enums.courseTaskType.exam": "考试",
  "edu.enums.courseTaskType.assignment": "作业",
  "edu.enums.courseTaskType.exercise": "练习",
  "edu.enums.courseTaskType.download": "下载资料",
  "edu.enums.courseRequiredKind.required": "必修",
  "edu.enums.courseRequiredKind.optional": "选修",
  "edu.enums.courseRequiredChapterKind.required": "必修章节",
  "edu.enums.courseRequiredChapterKind.optional": "选修章节",
  "edu.enums.courseRequiredLessonKind.required": "必修课时",
  "edu.enums.courseRequiredLessonKind.optional": "选修课时",
  "edu.enums.courseTaskStage.before_class": "课前",
  "edu.enums.courseTaskStage.in_class": "课中",
  "edu.enums.courseTaskStage.after_class": "课后",
  "edu.enums.taskCompletionPolicy.manual_mark": "标记完成",
  "edu.enums.taskCompletionPolicy.view_percent": "观看达到 N%",
  "edu.enums.taskCompletionPolicy.submit_once": "提交一次后完成",
  "edu.enums.taskCompletionPolicy.teacher_review": "提交后由老师批改",
  "edu.enums.taskCompletionPolicy.exam_pass": "考试达到 N 分",
  "edu.enums.taskCompletionPolicy.download_once": "下载资料后完成",
  "edu.enums.taskCompletionPolicy.discussion_reply": "参与讨论后完成",
  "edu.enums.taskCompletionPolicySummary.view_percent": "观看达到 {percent}%",
  "edu.enums.taskCompletionPolicySummary.exam_pass": "考试达到 {score} 分",
  "edu.enums.publicCourseSource.system": "系统内置",
  "edu.enums.publicCourseSource.shared": "共享课程",
  "edu.enums.publicCourseStatus.published": "已发布",
  "edu.enums.publicCourseStatus.staged": "待上架",
  "edu.enums.publicCourseStatus.paused": "已暂停",
  "edu.enums.projectLifecycle.draft": "草稿",
  "edu.enums.projectLifecycle.published": "已发布",
  "edu.enums.projectLifecycle.ended": "已结束",
  "edu.enums.projectExecution.not_started": "未开始",
  "edu.enums.projectExecution.in_progress": "进行中",
  "edu.enums.projectExecution.completed": "已完成",
  "edu.enums.projectExecution.history": "历史回看",
  "edu.enums.projectNodeType.course": "课程节点",
  "edu.enums.projectNodeType.exam": "考试节点",
  "edu.enums.projectMemberStatus.not_started": "未开始",
  "edu.enums.projectMemberStatus.in_progress": "进行中",
  "edu.enums.projectMemberStatus.completed": "已完成",
  "edu.enums.projectMemberStatus.history": "历史回看",
  "edu.enums.projectResultStatus.in_progress": "进行中",
  "edu.enums.projectResultStatus.completed": "已完成",
  "edu.enums.projectStepCompletion.required": "计入项目完成",
  "edu.enums.projectStepCompletion.optional": "仅学习明细",
  "edu.enums.projectNoticeSource.manual": "教师通知",
  "edu.enums.projectNoticeSource.members_updated": "成员调整",
  "edu.enums.projectNoticeSource.steps_updated": "路径调整",
  "edu.enums.projectNoticeSource.step_manual_released": "步骤放开",
  "edu.enums.projectNoticeSource.project_published": "项目发布",
  "edu.enums.projectNoticeSource.project_ended": "项目结束",
  "edu.enums.publicCourseNoticeSource.manual": "教师通知",
  "edu.enums.teachingPlanLifecycle.draft": "草稿",
  "edu.enums.teachingPlanLifecycle.published": "已发布",
  "edu.enums.teachingPlanLifecycle.ended": "已结束",
  "edu.enums.teachingPlanProgression.free": "自由学习",
  "edu.enums.teachingPlanProgression.unlock": "解锁式学习",
  "edu.enums.teachingPlanMemberStatus.not_started": "未开始",
  "edu.enums.teachingPlanMemberStatus.in_progress": "进行中",
  "edu.enums.teachingPlanMemberStatus.completed": "已完成",
  "edu.enums.teachingPlanMemberStatus.history": "历史回看",
  "edu.enums.teachingPlanSubmission.submitted": "已提交",
  "edu.enums.teachingPlanSubmission.reviewed": "已批改",
  "edu.enums.teachingPlanSubmission.rejected": "已驳回",
  "edu.enums.diagnostics.undefined": "未定义{kind} ({rawValue})",
  "edu.enums.diagnostics.missing": "缺少{kind}",
  "edu.enums.kinds.courseSourceType": "课程来源类型",
  "edu.enums.kinds.courseLifecycleStatus": "课程生命周期",
  "edu.enums.kinds.publicCourseSourceType": "公开课来源类型",
  "edu.enums.kinds.publicCoursePublishStatus": "公开课状态",
  "edu.enums.kinds.projectLifecycleStatus": "培训项目生命周期",
  "edu.enums.kinds.projectExecutionStatus": "培训项目执行状态",
  "edu.enums.kinds.projectNodeType": "培训项目节点类型",
  "edu.enums.kinds.projectMemberStatus": "培训项目成员状态",
  "edu.enums.kinds.projectResultStatus": "培训项目完成结果",
  "edu.enums.kinds.projectStepCompletion": "培训项目完成性",
  "edu.enums.kinds.projectNoticeSourceKind": "培训项目通知来源",
  "edu.enums.kinds.publicCourseNoticeSourceKind": "公开课通知来源",
  "edu.enums.kinds.teachingPlanLifecycleStatus": "教学计划生命周期",
  "edu.enums.kinds.teachingPlanProgressionMode": "教学计划推进方式",
  "edu.enums.kinds.teachingPlanMemberStatus": "教学计划成员状态",
  "edu.enums.kinds.teachingPlanSubmissionStatus": "教学任务提交状态",
  "edu.pages.catalogDefaults.newTaskTitle": "新教学任务",
  "edu.pages.catalogDefaults.newLessonTitle": "新课时",
  "edu.pages.catalogDefaults.newChapterTitle": "新章节",
  "edu.pages.catalogDefaults.inClassStageSummary": "课中：完成本课时学习。",
  "edu.pages.catalogDefaults.freeLearningUnlockRule": "自由学习",
  "edu.pages.shared.labels.course": "课程",
  "edu.pages.shared.labels.source": "来源",
  "edu.pages.shared.labels.chapter": "章节",
  "edu.pages.shared.labels.lesson": "课时",
  "edu.pages.shared.labels.task": "教学任务",
  "edu.pages.shared.labels.teachingPlan": "教学计划",
  "edu.pages.shared.labels.owner": "负责人",
  "edu.pages.shared.labels.chapterIndexed": "章节 {index}",
  "edu.pages.shared.labels.lessonIndexed": "课时 {index}",
  "edu.pages.shared.labels.taskIndexed": "教学任务 {index}",
  "edu.pages.shared.labels.stepIndexed": "步骤 {index}",
  "edu.pages.shared.labels.version": "版本 {value}",
  "edu.pages.shared.labels.generatedAt": "生成时间：{value}",
  "edu.pages.shared.labels.recentActivity": "最近活动：{value}",
  "edu.pages.shared.units.percent": "%",
  "edu.pages.shared.units.score": "分",
  "edu.pages.shared.units.count": "{count} 个",
} satisfies MessageTree;

export const eduCommonMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
